/* eslint no-console:0 */
// Minimal pack for unauthenticated pages (login, reset password, verification).
// Unlike application.js which loads the entire app with require.context,
// this pack explicitly registers only the components needed on pre-auth pages.
// This keeps the bundle small and avoids loading authenticated-only code.

var ReactRailsUJS = require('react_ujs')

// Explicitly import only the components mounted via react_component in
// views that use the 'default' layout (login, reset, verification).
var ResetPasswordRouter  = require('react/components/router/ResetPasswordRouter').default
var VerificationRouter   = require('react/components/router/VerificationRouter').default
var Login                = require('react/components/shell/Authentication/Login').default
var ConnectRedirect      = require('react/components/shell/Authentication/Common/ConnectRedirect').default
var InternalErrorMessage = require('react/components/shell/Authentication/Common/InternalErrorMessage').default

// Register a custom constructor lookup that maps the component names used
// in Rails react_component calls to the imported modules.
var components = {
  'components/router/ResetPasswordRouter':                    ResetPasswordRouter,
  'components/router/VerificationRouter':                     VerificationRouter,
  'components/shell/Authentication/Login':                    Login,
  'components/shell/Authentication/Common/ConnectRedirect':   ConnectRedirect,
  'components/shell/Authentication/Common/InternalErrorMessage': InternalErrorMessage,
}

ReactRailsUJS.getConstructor = function(className) {
  var component = components[className]
  if (component) return component
  throw new Error(
    'Could not find component \'' + className + '\' in unauthenticated pack. ' +
    'Available components: ' + Object.keys(components).join(', ')
  )
}

ReactRailsUJS.mountComponents()
